function setCookie(name, value, eDate, domain) {
    var date = new Date(Date.parse(eDate));
    var expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + (value || "") + expires + ";domain=" + domain + "; path=/";
}
function showPopup(pHeading, pMessage, isSuccess, lblViewCart, urlViewCart) {
    $('#cartModal .modal-title').text(pHeading);
    var msg = '</div>' +
        '<p>' + pMessage + '</p>' +
        '</div>';
    if (isSuccess) {
        msg = msg + '<div><h5><a href="' + urlViewCart + '">' + lblViewCart + '</a></h5></div>';
    }
    $('#cartModal .modal-body').empty();
    $('#cartModal .modal-body').append(msg);
    $('#cartModal').modal();
}
$(document).ready(function () {
    $(".btn-addCart").click(function () {
        var divAddCartSection = $(this).closest('.add-cart-section');
        if (divAddCartSection.length) {
            var sku = divAddCartSection.data("sku");
            var name = divAddCartSection.data("name");
            var unitOfMeasure = divAddCartSection.data("unit");
            var languageCode = $('html')[0].lang;
            var qtyOrdered = 1;
            var viewCartLabel = divAddCartSection.data("viewcartlabel");
            var viewCartUrl = $(".header__cart a").attr("href");
            var failureMsgHeading = divAddCartSection.data("fatclabel");
            var successMsgHeading = divAddCartSection.data("satclabel");
            var shortDesc = divAddCartSection.data("sdsca");
            var price = divAddCartSection.data("price");
            var currencyCode = divAddCartSection.data("currencycode")
        }
        var request = {
            "Sku": sku,
            "QtyOrdered": qtyOrdered,
            "UnitOfMeasure": unitOfMeasure,
            "LanguageCode": languageCode
        };
        $.ajax({
            url: '/b2c-api/addtocart',
            data: request,
            accept: 'application/json; charset=utf-8',
            dataType: 'json',
            xhrFields: {
                withCredentials: true
            },
            success: function (data, textStatus, xhr) {
                var cookies = data.CookieCollection;
                if (cookies) {
                    jQuery.each(cookies, function (i, cookie) {
                        setCookie(cookie.Name, cookie.Value, cookie.Expires, cookie.Domain);
                    });
                }
                if (data.TotalItems >= 0) {
                    $(".header__cart-items").removeAttr("style");
                    $('.header__cart-items').text(data.TotalItems);
                    showPopup(successMsgHeading, data.Message, true, viewCartLabel, viewCartUrl);
                }
                else {
                    showPopup(failureMsgHeading, data.Message, false, viewCartLabel, viewCartUrl);
                }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                var errorMessage = 'Call Failed';
                showPopup(failureMsgHeading, errorMessage, false, viewCartLabel, viewCartUrl);
            }
        });

        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
                items: [
                    {
                        item_name: shortDesc,
                        item_id: name,
                        price: price,
                        quantity: qtyOrdered,
                        currency: currencyCode
                    }
                ]
            }
        });
    });
});